const splitFullName = (fullName = '') => {
	const context = fullName.trim().split(' ');
	const firstName = context[0];
	const lastName = fullName.substring(firstName.length).trim();

	return {
        firstName,
        lastName,
    };
};

export { splitFullName };